export const PageDataState = {
    Searchs: {
        office_department_id: {
            type: 'select',
            id: 'office_department_id',
            label: 'สำนักงาน / กรม',
            value: '',
            placeholder: 'สังกัดสำนักงาน / กรม',
        },
        office_division_name: {
            type: 'text',
            id: 'office_division_name',
            label: 'สำนัก / กอง',
            value: '',
            placeholder: 'สังกัดสำนัก / กอง',
        },
        office_division_status: {
            type: 'select',
            id: 'office_division_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        office_department_id: {
            type: 'select',
            id: 'office_department_id',
            label: 'สังกัดสำนักงาน / กรม',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'สังกัดสำนัก / กอง',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}